import { useMutation, useQueryClient } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

interface InviteData {
  email: string
  phone?: string
}

export const inviteUser = (data: InviteData) => postRequest('/users/invites', data)

export const useInviteUser = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: InviteData) => inviteUser(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queries.invites.list.queryKey })
    },
  })
}
